import Cookies from 'universal-cookie';

const cookies = new Cookies();

const getCookies = () => cookies;

export default getCookies;
